export default {
  en: {
    title: 'Reset your password',
    subtitle: 'Please enter your new password below. You will be logged in directly after resetting your password',
    back_to_login_prompt: 'Back to login',
    reset_password_button_prompt: 'Reset Password',
  },
};
